import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    color: theme.palette.facet.primaryBlue,
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  icon: {},
  iconWrapper: {
    padding: theme.spacing(0.5),
    backgroundColor: theme.palette.grey[200],
    borderRadius: theme.radius.xl,
    marginRight: theme.spacing(2),
  },
});

const LineItem = ({
  className,
  classes,
  icon,
  title,
  value,
}) => {
  const Icon = () => icon;
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={classes.titleWrapper}>
        <div className={classes.iconWrapper}>
          {icon && <Icon className={classes.icon} />}
        </div>
        <Typography
          className={classes.title}
          variant={'h5'}
          weight={'bold'}
        >
          {title}
        </Typography>
      </div>
      <Typography
        className={classes.title}
        variant={'h5'}
        weight={'medium'}
      >
        {value}
      </Typography>
    </Box>
  );
};

LineItem.defaultProps = {
  className: '',
  icon: null,
};

LineItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default withStyles(styles)(LineItem);
